module.exports = __webpack_public_path__ + "f6847d2e75f9e3005bd41ad0b0df9f1e.svg";